import './Helper/style';

const Title = props => {
	const { className = 'mt20 mb5', children } = props;

	return <p className={`bPlLabel ${className}`}>{children}</p>
};
export default Title;